<template>
  <div class="radio-list-input-container mb-3">
    <label class="questionHeader">
      <question-display :question="question"></question-display>
    </label>
    <div v-if="question['selection-list'] && question['selection-list'].category">
      <div v-for="(options, category) in categorizedOptions" :key="category" class="mb-4" style="display: inline-block;">
        <h5>{{ category }}</h5>
        <div v-for="option in options" :key="option.value" class="col-sm-6 col-xs-12">
          <label class="curved-checkbox">
            <input 
              type="radio" 
              :value="option.value" 
              v-model="inputValue.key" 
              @change="updateInput" 
              class="form-check-input" 
            /> 
            {{ option.name }}
          </label>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-for="option in question.options" :key="option" class="col-sm-6 col-xs-12">
        <label class="curved-checkbox">
          <input 
            type="radio" 
            :value="option" 
            v-model="inputValue.key" 
            @change="updateInput" 
            class="form-check-input" 
          /> 
          {{ option }}
        </label>
      </div>
    </div>
    <div v-if="isOtherSelected" class="mt-3">
      <input
        type="text"
        v-model="inputValue.others"
        placeholder="Please specify"
        class="form-control"
        @input="updateOtherSpecify"
      />
    </div>
    <small v-if="showValidation && question.required && !inputValue.key" class="text-danger">This field is required.</small>
  </div>
</template>

<script>
import dropdownValues from "@/assets/data/dropdown-values/dropdown.json";
import surveyService from '@/services/surveyService'; // Import the survey service
import QuestionDisplay from '../utils/QuestionDisplay.vue';

export default {
  components: {
      QuestionDisplay
  },
  props: {
    question: Object,
    required: Boolean,
    showValidation: Boolean // Add showValidation prop
  },
  data() {
    return {
      inputValue: surveyService.getAnswer(this.question.id) || { key: '', others: '' }
    };
  },
  computed: {
    categorizedOptions() {
      const categories = {};
      let optionsList = this.question.options || [];
      
      if (this.question['selection-list'] && this.question['selection-list'].category) {
        const key = this.question['selection-list'].value;
        optionsList = dropdownValues[key] || [];
      }
      
      optionsList.forEach(option => {
        if (!categories[option.category]) {
          categories[option.category] = [];
        }
        categories[option.category].push(option);
      });
      
      return categories;
    },
    isOtherSelected() {
      return this.inputValue.key === "14" || this.inputValue.key === "Other (Specify)";
    }
  },
  methods: {
    updateInput() {
      surveyService.setAnswer(this.question.id, this.inputValue); // Save the answer directly through the service
      this.$emit("input", this.inputValue);
    },
    updateOtherSpecify() {
      surveyService.setAnswer(this.question.id, this.inputValue); // Save the "Other (Specify)" value directly through the service
      this.$emit("input", this.inputValue);
    }
  },
  watch: {
    question(newQuestion) {
      this.inputValue = surveyService.getAnswer(newQuestion.id) || { key: '', others: '' };
    }
  }
};
</script>